import { ReactNode } from 'react';
import { IDataSource, FieldEventDataProps } from '@flos/react-components';
import { product } from 'c9-tracking';
import { C9Logger } from 'c9-js-log-client';

import { IAppConfig } from './IAppConfig';
import {
    CLAIM_TYPE,
    EMAIL_EVENT,
    IGetCustomerContentStatus,
    IPackageDetailsListType,
    TERMINATION_WHEN
} from './IPayload';

export interface HippoResources {
    [key: string]: string;
}

export interface ITextFieldData {
    value: string;
    status: string;
    event: string;
}

export interface IAlreadyCovered {
    index: number;
    value: boolean;
}

export interface IAboutYouData {
    name: string;
    addr: string;
    phone: string;
    email: string;
    updateInfo: boolean;
}

export interface ISelectedPaymentOptions {
    type: string;
    amount: string;
    unit: string;
}

export interface ICompanyHistory {
    name: string;
    id: string;
    start: string;
    end: string;
    days: number;
    claims: string;
    claimsType: [
        {
            type: string;
            compensation: string; // the amount
        }
    ];
}

export interface GiftCardServiceData {
    amount: string;
    key: string;
    status: 'active' | 'inactive';
    campaign: string;
}

export interface IAppProviderState {
    loggedInCustomerHouseholdsize: number;
    householdSize: number;
    alreadyCovered: IAlreadyCovered;
    notAlreadyCoveredReason: IDataSource | undefined;
    aboutYouData: IAboutYouData;
    customerContentStatus: IGetCustomerContentStatus;
    isCustomer: boolean | undefined;
    numberOfClaims: number;
    claimTypeSelected: IDataSource | undefined;
    claimType: CLAIM_TYPE | undefined;
    claimTypeDanish?: string;
    ecommerceProduct?: product;
    claimAmount: number;
    claimValue: string | null;
    cloudBurst: {
        value: string;
        compensation: string;
    };
    createPackage: any;
    cprNo: string | undefined;
    selectedDeductible: number | null;
    section: null | Map<string, any>;
    contentBlocks: HippoResources;
    selectedPackage: IPackageDetailsListType;
    address: FieldEventDataProps;
    terminationRequested: boolean | undefined;
    terminationWhen: TERMINATION_WHEN | undefined;
    terminationCompany: string | undefined;
    effectiveDate: string | undefined;
    updatedCoverages: any;
    bankInfo: IAccountInfo;
    updatedExtraCoverages: Array<string>;
    selectedPaymentOption: ISelectedPaymentOptions | undefined;
    emailEvent: EMAIL_EVENT;
    terms: [boolean, boolean, boolean, boolean];
    termsIsSubmitted: boolean;
    salesComplete: boolean;
    hasError: boolean;
    initialState: boolean;
    stateChange: boolean;
    isLoading: boolean;
    telephone: string;
    prizeZero: boolean;
    emailSent: boolean;
    refreshFromCache: boolean;
    resourcesReady: boolean;
    bannerText: string;
    bannerHeader: string;
    overlayText: string;
    showBannerOverlay: boolean;
    hasEboksSubscription: boolean;
    giftCard: GiftCardServiceData | null;
    actualStep: number;
    previousStep: number;
    customerHasMarking: boolean | null;
    isLateLogin: boolean;
}

export interface IAppProps {
    config: IAppConfig;
    c9log: C9Logger;
    pageType: string;
    children?: ReactNode;
}

export interface IAccountInfo {
    accNumber: string;
    regNumber: string;
}

export enum SCREEN_NAME {
    INTRO = 'hippoText',
    ADDRESS = 'address',
    ALREADYCUSTOMER = 'alreadyCustomer',
    HOUSEHOLDSIZE = 'houseHoldSize',
    ALREADYCOVERED = 'alreadyCovered',
    NOT_ALREADY_COVERED_REASON = 'notAlreadyCoveredReason',
    NOOFCLAIMS = 'noOfClaims',
    CLAIMTYPE = 'claimType',
    CLOUD_BURST = 'cloudBurst',
    CLAIMTYPE_SELECTED = 'claimType_selected',
    COMPLIANCE = 'compliance',
    COMPLIANCE_SUBMITTED = 'compliance_submitted',
    CLAIMAMOUNT = 'claimAmount',
    CALL_ME = 'callMe',
    AGE = 'age',
    CREATE_PACKAGE = 'create_package',
    ABOUT_YOU = 'about_you',
    PACKAGE_SELECTED = 'package_selected',
    DEDUCTIBLE = 'deductible',
    UPDATED_COVERAGES_DEDUC_SCREEN = 'updated_coverages_deduc_screen',
    TERMINATION = 'termination',
    PAYMENT_SCREEN_ONE = 'payment_screen_one',
    PAYMENT_SCREEN_TWO = 'payment_screen_two',
    UPDATED_EXTRA_COVERAGES = 'updated_extra_coverages',
    SET_EMAIL_EVENT = 'set_email_event',
    SET_SALES_COMPLETE = 'set_sales_complete',
    SET_STATE_CHANGE = 'set_state_change',
    SET_ECOMMERCE_PRODUCT = 'set_ecommerce_product',
    SET_ERROR = 'set_error',
    SET_INITIAL_STATE = 'set_initial_state',
    RELOAD_STATE = 'reload_state',
    LOADING_DATA = 'loading_data',
    PRICE_ZERO = 'price_zero',
    EMAIL_SENT = 'email_sent',
    REFRESH_FROM_CACHE = 'refresh_from_cache',
    RESOURCES_READY = 'resources_ready',
    RESET_FROM_BACK_BUTTON = 'reset_from_back_button',
    SET_BANNER_TEXTS = 'set_banner_texts',
    SHOW_BANNER_OVERLAY = 'show_banner_overlay',
    SET_EBOKS_SUBSCRIPTION = 'set_eboks_subscription',
    SET_GIFT_CARD = 'SET_GIFT_CARD',
    SET_PROGRESS = 'SET_PROGRESS',
    SET_CUSTOMER_HAS_MARKING = 'SET_CUSTOMER_HAS_MARKING',
    CUSTOMER_CONTENT_STATUS = 'CUSTOMER_CONTENT_STATUS',
    LOGGED_IN_CUSTOMER_HOUSEHOLD_SIZE = 'LOGGED_IN_CUSTOMER_HOUSEHOLD_SIZE',
    SET_STAKE_HOLDER_ADDRESS = 'SET_STAKE_HOLDER_ADDRESS',
    SET_IS_LATE_LOGIN = 'SET_IS_LATE_LOGIN'
}
